// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as ActivitiesRouteImport } from './routes/activities'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as RoomsAndParksRouteImport } from './routes/rooms-and-parks'
import { Route as ActivitiesFalconLakeFishingGuideRouteImport } from './routes/activities_.falcon-lake-fishing-guide'
import { Route as ActivitiesWinterTexansGuideRouteImport } from './routes/activities_.winter-texans-guide'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const ActivitiesRoute = ActivitiesRouteImport.update({
            id: '/activities',path: '/activities',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const RoomsAndParksRoute = RoomsAndParksRouteImport.update({
            id: '/rooms-and-parks',path: '/rooms-and-parks',getParentRoute: () => rootRouteImport
          })
const ActivitiesFalconLakeFishingGuideRoute = ActivitiesFalconLakeFishingGuideRouteImport.update({
            id: '/activities_/falcon-lake-fishing-guide',path: '/activities/falcon-lake-fishing-guide',getParentRoute: () => rootRouteImport
          })
const ActivitiesWinterTexansGuideRoute = ActivitiesWinterTexansGuideRouteImport.update({
            id: '/activities_/winter-texans-guide',path: '/activities/winter-texans-guide',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,ActivitiesRoute: ActivitiesRoute,ContactUsRoute: ContactUsRoute,RoomsAndParksRoute: RoomsAndParksRoute,ActivitiesFalconLakeFishingGuideRoute: ActivitiesFalconLakeFishingGuideRoute,ActivitiesWinterTexansGuideRoute: ActivitiesWinterTexansGuideRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)